(function (root) {
  // Einblenden beim Scrollen und weiches Erscheinen später Bilder; ohne dieses Skript steht alles sofort da.
  var doc = root.document;
  if (!doc || !root.IntersectionObserver || !root.matchMedia) return;

  // The second picture of a card waits in a template until someone points at the card.
  if (root.matchMedia('(hover: hover)').matches) {
    doc.addEventListener('pointerover', function (event) {
      var card = event.target.closest ? event.target.closest('.c-product-card') : null;
      var template = card && card.querySelector('template[data-card-hover]');
      var media = card && card.querySelector('.c-product-card__media');
      if (!template || !media) return;
      var picture = template.content.firstElementChild.cloneNode(true);
      template.remove();
      picture.addEventListener('load', function () { picture.setAttribute('data-loaded', ''); });
      media.appendChild(picture);
    }, { passive: true });
  }

  if (root.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Gemessen an der alten Seite: 150 ms zwischen zwei Elementen, Start 70 px über der Unterkante des Fensters, 0,5 s.
  var STEP = 150;
  var LINE = 70;
  var DURATION = 500;
  var IMAGE_DURATION = 800;
  var UNRENDERED = /^(STYLE|SCRIPT|TEMPLATE|LINK|NOSCRIPT|META)$/;
  var html = doc.documentElement;

  function items(container) {
    return Array.prototype.filter.call(container.children, function (child) {
      return !UNRENDERED.test(child.tagName);
    });
  }

  function isContainer(node) {
    var kind = node.getAttribute('data-reveal-items');
    return kind !== null && kind !== 'hero';
  }

  function ownDelay(node) {
    var value = parseInt(node.getAttribute('data-reveal-delay'), 10);
    return value > 0 ? value : 0;
  }

  // Every element that moves with this node and when: the node itself first, then its items one step apart.
  function collect(node, delay, out) {
    var start = delay;
    if (node.hasAttribute('data-reveal')) {
      out.push([node, delay]);
      start = delay + STEP;
    }
    if (isContainer(node)) {
      items(node).forEach(function (child, index) {
        if (isContainer(child)) {
          collect(child, start + STEP * index, out);
          out.push([child, -1]);
        } else {
          out.push([child, start + STEP * index]);
        }
      });
    }
    return out;
  }

  function show(node, animate) {
    var moving = collect(node, ownDelay(node), []);
    var longest = 0;
    node.classList.add('is-revealed');
    moving.forEach(function (entry) {
      var element = entry[0];
      if (isContainer(element)) element.classList.add('is-revealed');
      if (!animate || entry[1] < 0) return;
      element.style.setProperty('--reveal-delay', entry[1] + 'ms');
      longest = Math.max(longest, entry[1]);
    });
    if (!animate) return;
    var containers = moving.filter(function (entry) { return isContainer(entry[0]); }).map(function (entry) { return entry[0]; });
    containers.concat(node).forEach(function (element) { element.classList.add('is-revealing'); });
    moving.forEach(function (entry) { if (entry[1] >= 0 && entry[0].hasAttribute('data-reveal')) entry[0].classList.add('is-revealing'); });
    root.setTimeout(function () {
      moving.forEach(function (entry) {
        entry[0].classList.remove('is-revealing');
        entry[0].style.removeProperty('--reveal-delay');
      });
      node.classList.remove('is-revealing');
    }, longest + Math.max(DURATION, IMAGE_DURATION) + 100);
  }

  // "#id" names one element, ".class" the nearest one around the node; anything else is the node itself.
  function anchorOf(node) {
    var name = node.getAttribute('data-reveal-anchor') || '';
    if (name.charAt(0) === '#') return doc.getElementById(name.slice(1)) || node;
    if (/^\.[A-Za-z][A-Za-z0-9_-]*$/.test(name)) return node.closest(name) || node;
    return node;
  }

  function startReveal() {
    // An item of a container moves with it; everything else waits for its own anchor.
    var nodes = Array.prototype.filter.call(doc.querySelectorAll('[data-reveal], [data-reveal-items]'), function (node) {
      if (node.getAttribute('data-reveal-items') === 'hero' && !node.hasAttribute('data-reveal')) return false;
      var parent = node.parentElement;
      return !(parent && isContainer(parent));
    });
    if (nodes.length === 0) return;
    var waiting = new Map();
    nodes.forEach(function (node) {
      var anchor = anchorOf(node);
      if (!waiting.has(anchor)) waiting.set(anchor, []);
      waiting.get(anchor).push(node);
    });
    var line = root.innerHeight - LINE;
    // What the visitor already sees, or has scrolled past, stands at once: nothing on screen ever goes invisible.
    var early = [];
    waiting.forEach(function (list, anchor) {
      if (anchor.getBoundingClientRect().top < line) early.push(anchor);
    });
    early.forEach(function (anchor) {
      waiting.get(anchor).forEach(function (node) { show(node, false); });
      waiting.delete(anchor);
    });
    html.classList.add('reveal-on');
    if (waiting.size === 0) return;

    // The window reaches far up: an anchor a jump carried past still counts as come into view.
    var observer = new root.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var list = entry.isIntersecting && waiting.get(entry.target);
        if (!list) return;
        waiting.delete(entry.target);
        observer.unobserve(entry.target);
        list.forEach(function (node) { show(node, true); });
      });
      if (waiting.size === 0) observer.disconnect();
    }, { rootMargin: '100000px 0px -' + LINE + 'px 0px' });
    waiting.forEach(function (list, anchor) { observer.observe(anchor); });
  }

  // The frame that holds exactly the box of the picture carries the calm ground while it loads, unless it has a ground of its own.
  function frameOf(image, box) {
    var node = image.parentElement;
    for (var hops = 0; node && hops < 3; hops += 1) {
      var rect = node.getBoundingClientRect();
      if (Math.abs(rect.width - box.width) <= 1 && Math.abs(rect.height - box.height) <= 1) {
        var ground = root.getComputedStyle(node).backgroundColor;
        return ground === 'transparent' || ground === 'rgba(0, 0, 0, 0)' ? node : null;
      }
      node = node.parentElement;
    }
    return null;
  }

  function startImages() {
    var late = Array.prototype.filter.call(doc.querySelectorAll('img[loading="lazy"]'), function (image) {
      return !image.complete;
    });
    // All boxes first, then all classes: one layout for the whole page instead of one per picture.
    var fold = root.innerHeight;
    var framed = late.map(function (image) {
      var box = image.getBoundingClientRect();
      // What stands in the first screen already may be the largest paint; it appears the moment it has loaded.
      if (box.width > 0 && box.height > 0 && box.top < fold) return null;
      return [image, box.width > 0 && box.height > 0 ? frameOf(image, box) : null];
    }).filter(Boolean);
    framed.forEach(function (pair) {
      if (pair[0].complete) return;
      pair[0].classList.add('is-image-pending');
      if (pair[1]) pair[1].classList.add('is-image-frame');
    });
    // One listener for every waiting picture: a band that copies its pictures copies the waiting class along, and the copy arrives too.
    function arrive(event) {
      var image = event.target;
      if (!image || image.tagName !== 'IMG' || !image.classList.contains('is-image-pending')) return;
      var frame = null;
      for (var node = image.parentElement, hops = 0; node && hops < 3; node = node.parentElement, hops += 1) {
        if (node.classList.contains('is-image-frame')) { frame = node; break; }
      }
      image.classList.add('is-image-arriving');
      image.classList.remove('is-image-pending');
      if (frame) frame.classList.add('is-image-landed');
      root.setTimeout(function () {
        image.classList.remove('is-image-arriving');
        if (frame) frame.classList.remove('is-image-frame', 'is-image-landed');
      }, DURATION + 100);
    }
    doc.addEventListener('load', arrive, true);
    doc.addEventListener('error', arrive, true);
  }

  startImages();
  startReveal();
})(window);
